// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"teamcards_singleCard__3fxdK","logo":"teamcards_logo__2xfyb"};